import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function ContactPage() {
  return <Layout data-id="element-352">
      <section className="min-h-screen bg-alabaster flex flex-col lg:flex-row" data-id="element-353">
        {/* Left Side: Info */}
        <div className="flex-1 p-8 md:p-24 flex flex-col justify-center border-b-3 lg:border-b-0 lg:border-r-3 border-charcoal" data-id="element-354">
          <div className="max-w-md mx-auto lg:mx-0" data-id="element-355">
            <span className="inline-block bg-espresso/10 text-espresso px-4 py-2 font-bold uppercase tracking-widest text-xs mb-6" data-id="element-356">
              Get In Touch
            </span>
            <h1 className="text-5xl md:text-6xl font-bold mb-8" data-id="element-357">
              Let's Start Your Project.
            </h1>
            <p className="text-charcoal/60 mb-12 leading-relaxed" data-id="element-358">
              Ready to transform your kitchen? Contact our Bowie design center
              to schedule a consultation or request a detailed quote.
            </p>

            <div className="space-y-8" data-id="element-359">
              <div className="flex gap-6" data-id="element-360">
                <div className="w-12 h-12 border-2 border-espresso flex items-center justify-center shrink-0" data-id="element-361">
                  <PhoneIcon className="w-5 h-5 text-espresso" data-id="element-362" />
                </div>
                <div data-id="element-363">
                  <h4 className="font-bold uppercase tracking-widest text-xs mb-1" data-id="element-364">
                    Call Us
                  </h4>
                  <p className="text-lg font-bold" data-id="element-365">(301) 555-0123</p>
                </div>
              </div>

              <div className="flex gap-6" data-id="element-366">
                <div className="w-12 h-12 border-2 border-espresso flex items-center justify-center shrink-0" data-id="element-367">
                  <MailIcon className="w-5 h-5 text-espresso" data-id="element-368" />
                </div>
                <div data-id="element-369">
                  <h4 className="font-bold uppercase tracking-widest text-xs mb-1" data-id="element-370">
                    Email Us
                  </h4>
                  <p className="text-lg font-bold" data-id="element-371">hello@nkrefacers.com</p>
                </div>
              </div>

              <div className="flex gap-6" data-id="element-372">
                <div className="w-12 h-12 border-2 border-espresso flex items-center justify-center shrink-0" data-id="element-373">
                  <MapPinIcon className="w-5 h-5 text-espresso" data-id="element-374" />
                </div>
                <div data-id="element-375">
                  <h4 className="font-bold uppercase tracking-widest text-xs mb-1" data-id="element-376">
                    Visit Us
                  </h4>
                  <p className="text-lg font-bold" data-id="element-377">
                    1234 Craftsmanship Way,
                    <br data-id="element-378" />
                    Bowie, MD 20715
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="flex-1 bg-white p-8 md:p-24 flex items-center justify-center" data-id="element-379">
          <div className="w-full max-w-md" data-id="element-380">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-381">
              <div className="grid grid-cols-2 gap-6" data-id="element-382">
                <div className="space-y-2" data-id="element-383">
                  <label className="text-xs font-bold uppercase tracking-widest" data-id="element-384">
                    First Name
                  </label>
                  <input type="text" className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 transition-colors" placeholder="Jane" data-id="element-385" />
                </div>
                <div className="space-y-2" data-id="element-386">
                  <label className="text-xs font-bold uppercase tracking-widest" data-id="element-387">
                    Last Name
                  </label>
                  <input type="text" className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 transition-colors" placeholder="Doe" data-id="element-388" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-389">
                <label className="text-xs font-bold uppercase tracking-widest" data-id="element-390">
                  Email Address
                </label>
                <input type="email" className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 transition-colors" placeholder="jane@example.com" data-id="element-391" />
              </div>

              <div className="space-y-2" data-id="element-392">
                <label className="text-xs font-bold uppercase tracking-widest" data-id="element-393">
                  Project Type
                </label>
                <select className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 bg-transparent transition-colors" data-id="element-394">
                  <option data-id="element-395">Full Cabinet Refacing</option>
                  <option data-id="element-396">Door Replacement Only</option>
                  <option data-id="element-397">Hardware Upgrade</option>
                  <option data-id="element-398">General Inquiry</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-399">
                <label className="text-xs font-bold uppercase tracking-widest" data-id="element-400">
                  Message
                </label>
                <textarea className="w-full border-b-2 border-charcoal/10 focus:border-espresso outline-none py-3 min-h-[120px] transition-colors" placeholder="Tell us about your kitchen..." data-id="element-401"></textarea>
              </div>

              <button className="w-full bg-charcoal text-alabaster py-5 font-bold uppercase tracking-[0.2em] text-sm hover:bg-espresso transition-colors mt-8" data-id="element-402">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </Layout>;
}